import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DriverStatusModel, DriverStatusObject, LogRecordStatus, ThemeMode, ThemeModeService } from '@fleet-beat/core';
import { StatusIconConfigModel } from '@fleet-beat/shared';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fb-driver-status-icon',
  templateUrl: './driver-status-icon.component.html',
  styleUrls: ['./driver-status-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverStatusIconComponent {
  @Input() set status(status: LogRecordStatus) {
    this._status = this.getDriverStatusObject(status);
    this.setIconConfig();
  }
  iconConfig: StatusIconConfigModel;

  _status: DriverStatusModel;

  currentThemeSubject: BehaviorSubject<ThemeMode>;
  constructor(private themeModeService: ThemeModeService) {
    this.currentThemeSubject = this.themeModeService.themeModeSubject;
  }

  private setIconConfig(): void {
    this.iconConfig = this._status.iconConfig;
  }

  private getDriverStatusObject(status: LogRecordStatus): DriverStatusModel {
    switch (status) {
      case LogRecordStatus.Driving:
        return DriverStatusObject.driving;

      case LogRecordStatus.OffDuty:
        return DriverStatusObject.off;
      case LogRecordStatus.OnDuty:
        return DriverStatusObject.onDuty;
      case LogRecordStatus.PersonalConveyance:
        return DriverStatusObject.personalConveyance;
      case LogRecordStatus.SleeperBerth:
        return DriverStatusObject.sleepBerth;
      case LogRecordStatus.YardMove:
        return DriverStatusObject.yardMove;
      case LogRecordStatus.PowerOffConventional:
        return DriverStatusObject.powerOff;
      case LogRecordStatus.PowerOnConventional:
        return DriverStatusObject.powerOn;
      case LogRecordStatus.IntermediateConventional:
        return DriverStatusObject.intermediate;
      case LogRecordStatus.Certification:
        return DriverStatusObject.certification;
      case LogRecordStatus.Login:
        return DriverStatusObject.login;
      case LogRecordStatus.Logout:
        return DriverStatusObject.logout;
      default:
        return DriverStatusObject.off;
    }
  }
}
